import React, { Component } from 'react';
import { Modal } from 'antd-mobile';
import PropTypes from 'prop-types';
import SendVRCode from '../../../components/sendVRCode';

import styles from './style.module.less';

const propTypes = {
  liveLoginVisible: PropTypes.bool,
  handleMobileLogin: PropTypes.func,
};
const defaultProps = {
  liveLoginVisible: false,
  handleMobileLogin: () => {},
};

class LiveLogin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mobile: undefined,
      code: undefined,
    };
  }

  handleChange = (key) => (event) => {
    const { value } = event.target;
    this.setState({ [key]: value });
  }

  scrollPosition = () => {
    const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
    window.scrollTo(0, Math.max(scrollHeight - 1, 0));
  }

  render() {
    const { mobile, code } = this.state;
    const { liveLoginVisible, handleMobileLogin } = this.props;
    return (
      <div>
        <Modal popup visible={liveLoginVisible} className={styles.popupLiveLogin} animationType="slide-up">
          <div className={styles.contentBox}>
            <div className={styles.inputBox}>
              <input
                maxLength={11}
                type="text"
                onBlur={this.scrollPosition}
                placeholder="请输入手机号"
                onChange={this.handleChange('mobile')}
                value={mobile}
              />
            </div>
            <div className={styles.inputBox}>
              <input
                type="text"
                maxLength={6}
                placeholder="验证码"
                onBlur={this.scrollPosition}
                onChange={this.handleChange('code')}
                value={code}
              />
              <div className={styles.right}>
                <SendVRCode type="live" phoneNumber={mobile} className={styles.sendCode} />
              </div>
            </div>
            <div className={styles.button} onClick={handleMobileLogin.bind(this, mobile, code)} role="button" tabIndex={0}>登 录</div>
          </div>
        </Modal>
      </div>
    );
  }
}

LiveLogin.propTypes = propTypes;
LiveLogin.defaultProps = defaultProps;

export default LiveLogin;
